<template>
  <!-- 调整学员名单页面🤐 -->
  <div class="edit_stus_info-root">
    <div class="main-content-wrap">
      <yioks-page-nav @backBtnHandle="goBack" class="nav-wrap">
        <p class="title">调整学员名单</p>
        <div class="nav-right" slot="right">
          <!--<select class="select date" v-model="group_mode">-->
          <!--<option :key=3  :value=3>三人一组(默认分组)</option>-->
          <!--<option :key=4  :value=4>四人一组(默认分组)</option>-->
          <!--</select>-->
          <span class="zuxie-btn load-btn" @click="ifExcelDiaShow = true">批量修改</span>
        </div>
      </yioks-page-nav>
      <div class="content-wrap">
        <vue-scroll :ops="vuescrollOpt" ref="stuVs">
          <div class="form-box">
            <el-form
                :model="stusData"
                ref="infoForm"
                label-width="60px"
                size="medium"
                class="info-form"
            >
              <div
                  class="form-oneline-wrap clearfix"
                  v-for="(stu, index) in stusData.stusInfoList"
                  :key="stu.id"
              >
                <span class="num">{{index+1}}</span>
                <el-form-item
                    label="姓名"
                    label-width="45px"
                    :prop="'stusInfoList.' + index + '.name'"
                    :rules="{required: true, validator: (rule, value, callback) => {validateName(rule, value, callback, index, 'name')}, trigger: 'blur'}"
                    class="dia-input-wrap stu-name-wrap"
                >
                  <el-input placeholder="请输入姓名" v-model="stu.name" class="dia-input-w160 name-input"></el-input>
                </el-form-item>
                <el-form-item
                    label="手机号"
                    :prop="'stusInfoList.' + index + '.phone'"
                    :rules="{required: true, validator: (rule, value, callback) => {validatePhone(rule, value, callback, index, 'phone')}, trigger: 'blur'}"
                    class="dia-input-wrap stu-phone-wrap"
                >
                  <el-input placeholder="请输入手机号" v-model.trim="stu.phone" class="dia-input-w160 phone-input"></el-input>
                </el-form-item>
                <el-form-item label="证件类型"
                label-width="78px"
                :prop="'stusInfoList.' + index + '.id_type'"
                :rules="{required:true,message:'请选择证件类型',trigger:'change'}"
                class="dia-input-wrap stu-type-wrap" >
                  <el-select v-model="stu.id_type" style='width:200px'>
                    <el-option
                    v-for="item in id_types"
                    :key="item.key"
                    :label="item.key"
                    :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  ref="s"
                    label="证件号"
                    :prop="'stusInfoList.' + index + '.id_num'"
                    :rules="{required: true, validator: (rule, value, callback) => {validateNumberId(rule, value, callback, index, 'id_num')}, trigger: 'blur'}"
                    class="dia-input-wrap stu-phone-wrap"
                >
                  <el-input placeholder="请输入证件号" v-model.trim="stu.id_num" class="dia-input-w180"></el-input>
                </el-form-item>
                <div class="stu-opt">
                  <i :class="{'el-icon-circle-plus': true, 'opt-icon': true, add: stusData.stusInfoList.length<maxStus, disabled: stusData.stusInfoList.length>=maxStus}"
                     @click="addStus(index)"
                     v-if="index ===stusData.stusInfoList.length-1"></i>
                  <i :class="{'el-icon-remove': true, 'opt-icon': true, remove: stusData.stusInfoList.length>1, disabled: stusData.stusInfoList.length<=1}"
                     @click="removeStus(index)"></i>
                </div>
              </div>
            </el-form>
          </div>
        </vue-scroll>
      </div>
      <div class="center-btn-group">
        <!--<el-button type="primary" @click="saveInfo">保存</el-button>-->
        <!--<el-button type="info" @click="goBack">取消</el-button>-->
        <div class="btns">
          <div class="btn save"
               @click="saveInfo">提交审核
          </div>
          <div class="btn cancel"
               @click="goBack">取消
          </div>
        </div>
      </div>
    </div>
    <el-dialog
        @closed="excelDiaCloseHandle"
        :visible.sync="ifExcelDiaShow"
        :close-on-click-modal="false"
        top="13vh"
        width="500px"
        class="yi-dialog-root"
    >
      <div class="slot-dialog-header" slot="title">
        <span class="title">批量录入</span>
      </div>
      <div class="excel-dia-content">
        <p class="upload-tips"><span style="color:red">温馨提示：</span> 2020年起开设的培训班将使用支持非大陆学员报名的新模板，旧模板将无法使用。</p>
        <file-upload
            class="excel-up"
            action="/api/organization/student_up_excel.json"
            :test_file="testFile"
            :val.sync="excelVal"
            ref="excelUpload"
        >
        </file-upload>
        <p class="upload-tips">
          <span>请上传 excel 文件 或&nbsp;</span>
          <a :href="loadExcelUrl"
             download="">下载模板</a>
          <span>&nbsp;编辑后上传</span>
        </p>
      </div>
      <div class="footer-btn" slot="footer">
        <!--<el-button type="primary" @click="saveExcelData">保存</el-button>-->
        <!--<el-button type="info" @click="ifExcelDiaShow = false">取消</el-button>-->
        <div class="btns">
          <div class="btn save"
               @click="saveExcelData">保存
          </div>
          <div class="btn cancel"
               @click="ifExcelDiaShow = false">取消
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- hideTips接收两个参数：参数1控制弹窗显示隐藏，参数2标记是否点击确定按钮(点击：true) -->
    <yioks-tips :showTips="tipsFlag"
                :tips="'确定放弃修改并返回吗？'"
                @hideTips="hideTipsDialog"></yioks-tips>
    <yioks-tips :showTips="deleteFlag"
                :tips="'确定移除该学员吗？'"
                @hideTips="hideDelDialog"></yioks-tips>
    <yioks-reason :flag="reasonFlag"
                  :title="'调整理由'"
                  :subTitle="'只能调整一次学员名单'"
                  :holderText="'请输入调整理由，例如张三由于身体原因，放弃参加本次培训，由李四代替。'"
                  :requiredReason="true"
                  :loading="loading"
                  @hideAdjust="hideAdjustDialog"></yioks-reason>
  </div>
</template>

<script>
  import createScrollOpt from "@/assets/js/vuescrollOption";
  import commonFun from "@/assets/js/yioks";
  import {
    getClassDetail,
    editStusInfoAjax,
    testStusAdjust
  } from "@/api/agency/agency";
  import {correctStatus} from "@/assets/js/apiStatus";
  import {operationMsgSave} from "@/api/common/api";
  import {id_types} from "@/assets/js/select";
  const {mobile_phone, idCard_number,checkWork,checkHkongMacao,checkTaiwOld,checkPassport,checkHMT} = commonFun;
  const HOSTURL = process.env.VUE_APP_URL;
  const excelFileUrl = "/uploads/import_tpl/批量录入学员模板.xlsx";

  const minStus = 18;
  const maxStus = 24;

  let stusErrLen = 0;
  const dataTestResults = Array(maxStus).fill(null).map(() => ({
    phone: {bool: false, msg: ""},
    id_num: {bool: false, msg: ""},
    name: {bool: false, msg: ""}
  }));
  let {values} = Object;
  export default {
    name: "EditStusInfo",
    props: {
      // 来自路由传递的值
      classId: [String, Number]
    },
    created() {
      this.getClassInfo();
    },
    data() {
      const validatePhone = (rule, value, callback, index, key) => {
        if (mobile_phone(value)) {
          // 如果后台校验手机号有问题
          if (dataTestResults[index][key].bool) {
            callback(new Error(dataTestResults[index][key].msg));
          } else {
            callback();
          }
        } else {
          callback(new Error("请输入有效的11位手机号"));
        }
      };
      const validateNumberId = (rule, value, callback, index, key) => {
        let id_type = this.stusData.stusInfoList[index].id_type
        let rules ;
        if(id_type==='id_number'){rules=idCard_number}
        else if(id_type==='idTypeCode_wgjzz'){rules=checkWork}
        else if(id_type==='passport'){rules=checkPassport}
        else if(id_type==='TAI'){rules=checkTaiwOld}
        else if(id_type==='HM'){rules=checkHkongMacao}
        else if(id_type==='idTypeCode_HMT'){rules=checkHMT}
        if (rules(value)) {
          if (dataTestResults[index][key].bool) {
            callback(new Error(dataTestResults[index][key].msg));
          } else {
            callback();
          }
        } else callback(new Error("请输入有效的证件号"));
      };
      const validateName = (rule, value, callback, index, key) => {
        if (value === "") {
          callback(new Error("请输入姓名"));
        } else {
          if (dataTestResults[index][key].bool) {
            callback(new Error(dataTestResults[index][key].msg));
          } else {
            callback();
          }
        }
      };
      const testFile = {
        type: {
          reg: /^.*\.(xls|xlsx)$/i,
          msg: "请上传Excel文件"
        },
        size: {
          reg: 20,
          msg: "文件不得多于20M"
        }
      };
      return {
        minStus,
        id_types,
        maxStus,
        loadExcelUrl: excelFileUrl,
        testFile,
        excelVal: "",
        validatePhone,
        validateNumberId,
        validateName,
        vuescrollOpt: createScrollOpt(),
        ifExcelDiaShow: false,
        tipsFlag: false,
        stusData: {
          stusInfoList: []
        },
        group_mode: 6,
        reasonFlag: false,
        deleteFlag: false,
        delIndex: null,
        loading:false
      };
    },
    components: {
      "yioks-page-nav": () => import("@/components/PageNav/PageNav"),
      "file-upload": () => import("@/components/UpFile/UpFile"),
      "yioks-tips": () => import("@/components/Tips/Dialog"),
      "yioks-reason": () => import("@/components/Tips/verify-adjust"),
    },
    methods: {
      // 显示后台校验24个学员名单的结果
      testStusInfo(idx, key, msg, i) {
        const index = idx - 1;
        dataTestResults[index][key].bool = true;
        dataTestResults[index][key].msg = msg;
        console.log('当前校验 ---》 ', dataTestResults[index][key])
        this.$refs["infoForm"].validateField("stusInfoList." + index + "." + key);
        if (stusErrLen - 1 === i) {
          for (const item of dataTestResults) {
            for (const key in item) {
              if (item.hasOwnProperty(key)) {
                item[key].bool = false;
                item[key].msg = "";
              }
            }
          }
        }
        this.$nextTick(() => {
        });
      },
      hideAdjustDialog(bool, flag, msg) {
        // this.reasonFlag = bool;
        if (flag) {
          this.loading=true
          this.adjustStusInfo(msg);
        }else {
          this.reasonFlag = bool;
        }
      },
      // 保存学员名单信息
      saveInfo() {
        this.$refs["infoForm"].validate(valid => {
          // 必须在18人到24人之间
          if (this.stusData.stusInfoList.length < minStus || this.stusData.stusInfoList.length > maxStus) {
            this.$message.error("学员数量必须在18人到24人之间");
          } else {
            if (valid) {
              this.reasonFlag = true;
            } else {
              this.$message.error("所填写的信息有误");
            }
          }
        });
      },
      adjustStusInfo(msg) {
        const {classId, stusData} = this;
        const {stusInfoList} = stusData;
        testStusAdjust({
          c_id: classId,
          student_list: JSON.stringify(
            stusInfoList.map(
              ({name, phone, id_num,id_type}, index) => ({
                name,
                phone,
                id_num,
                id: index + 1,
                id_type
              })
            )
          ),
        })
          .then(async ({data}) => {
            if (data.status === correctStatus) {
              let operation_msg_id = 0;
              const {result} = data;
              switch (result.consequence.toLowerCase()) {
                case "ok":
                  console.log("save");
                  const ajaxParams = {
                    c_id: classId,
                    group_mode: this.group_mode,
                    student_list: JSON.stringify(stusInfoList),
                    msg_info: msg
                  };
                  ajaxParams.operation_type='adjust';
                  await operationMsgSave(JSON.parse(JSON.stringify(ajaxParams))).then(({data}) =>{
                  operation_msg_id=data.result.operationMsg.msg_id;
                })
                  editStusInfoAjax({
                    c_id: classId,
                    group_mode: this.group_mode,
                    student_list: JSON.stringify(stusInfoList),
                    msg_info: msg,
                    operation_msg_id:operation_msg_id
                  })
                    .then(({data}) => {
                      if (data.status === correctStatus) {
                        this.$message.success("学员名单调整成功");
                        /*this.$router.push({
                          name: "TrainingClassDetail"
                        });*/
                        this.$router.go(-1);
                        this.loading=false;
                        this.reasonFlag = false;
                      }
                    })
                    .catch(err => {
                      this.loading=false;
                      console.warn(err);
                    });
                  break;
                // 后台校验数据有误，显示后端校验
                case "error":
                  // 校验学员名单
                  if (result.studentErr.length > 0) {
                    stusErrLen = result.studentErr.length;
                    for (const [
                      i,
                      {err, index_id}
                    ] of result.studentErr.entries()) {
                      for (const key in err) {
                        if (err.hasOwnProperty(key)) {
                          this.testStusInfo(index_id, key, err[key], i);
                        }
                      }
                    }
                  }
                  this.loading=false;
                  this.reasonFlag = false;
                  break;
              }
            } else {
              this.reasonFlag = false
            }
          })
          .catch(err => {
            this.loading=false;
            this.reasonFlag = false;
            console.warn(err);
          });
      },
      // 获取培训班基本信息
      getClassInfo(doOtherThing = () => {
      }) {
        getClassDetail({
          c_id: this.classId
        }).then(({data}) => {
          if (data.status === correctStatus) {
            this.stusData.stusInfoList = data.result.student_data.map(
              ({user_id, user_name, mobile_phone, id_number,id_type}) => ({
                // 使用 (|| '') 将后台传来的异常的数据如 null 转换为 ''，防止在表单校验时遇到 trim() 方法时报错😏😏😏
                name: user_name || "",
                phone: mobile_phone || "",
                id_num: id_number || "",
                id: user_id,
                id_type,
              })
            );
            const {group_list} = data.result;
            // this.group_mode = group_list.length === 6 ? 4 : 3; // 回传默认分组
            this.group_mode = group_list.length; // 回传默认分组
          }
        });
      },
      // 批量修改弹窗中上传 excel 文件中的保存按钮执行的函数
      saveExcelData() {
        if (this.excelVal !== "") {
          if (this.excelVal.student_list.length > this.maxStus) {
            this.$message.error("学员数量异常，请上传小于等于24人的名单");
            return;
          }
          this.ifExcelDiaShow = false;
          const excelData = [];
          for (const [i, item] of this.excelVal.student_list.entries()) {
            if (i >= maxStus) break;
            const stuItem = this.stusData.stusInfoList[i];
            // push 一个 { ...stuItem, ...item } 而不是 {...item} 是因为要保留原有每一项的id字段
            excelData.push({...stuItem, ...item});
            // this.$set(this.stusData.stusInfoList, i, { ...stuItem, ...item });
            // this.stusData.stusInfoList[i] = {...stuItem,...item}
            // console.log(this.stusData.stusInfoList[i], stuItem)
          }
          this.$refs["infoForm"].clearValidate()
          this.stusData.stusInfoList = [...excelData];
          /*const len = this.stusData.stusInfoList.length;
          if(len < this.maxStus) {
            for(let i = 0; i < (this.maxStus - len); i++) {
              this.stusData.stusInfoList.push({
                name: "",
                phone: "",
                id_num: ""
              });
            }
          }*/
          this.$nextTick(() => {
            // this.excelDiaLetStusDiaOpen = true
            this.ifStuDiaShow = true;
          });
        } else {
          this.$message.error("请先上传文件");
        }
      },
      excelDiaCloseHandle() {
        this.$refs["excelUpload"].reset();
      },
      goBack() {
        this.tipsFlag = true;
      },
      hideTipsDialog(bool, sure) {
        this.tipsFlag = bool;
        if (sure) {
          /*this.$router.push({
            name: "TrainingClassDetail"
          });*/
          this.$router.go(-1);
        } else {

        }
      },
      addStus(idx) {
        if (this.stusData.stusInfoList.length >= maxStus) return false;
        this.stusData.stusInfoList.push({
          name: "",
          phone: "",
          id_num: "",
          id_type:'id_number'
        });
        this.$nextTick(() => {
          this.$refs["stuVs"].scrollTo({y: '100%'}, true);
        });
      },
      removeStus(idx) {
        if (this.stusData.stusInfoList.length <= 1) return false;
        const {name, id_num, phone,id_type} = this.stusData.stusInfoList[idx];
        this.delIndex = idx;
        let flag = true;
        const info = {name, id_num, phone,id_type};
        for (let val of values(info)) {
          if(val !== "") {
            flag = false;
            break;
          }
        }
        if (flag) {
          this.$refs[`s`][idx].clearValidate();
          setTimeout(() => {
            this.stusData.stusInfoList.splice(idx, 1);
          }, 100);
        } else {
          this.deleteFlag = true;
        }
      },
      hideDelDialog(bool, sure) {
        this.deleteFlag = bool;
        if(sure) {
          this.$refs[`s`][this.delIndex].clearValidate();
          setTimeout(() => {
            this.stusData.stusInfoList.splice(this.delIndex, 1);
          }, 100);

        }
//        sure && this.stusData.stusInfoList.splice(this.delIndex, 1);
      },
    }
  };
</script>

<style lang="stylus">
  @import '~@/assets/css/variable'
  @import '~@/assets/css/mixin'
  @import '~@/assets/css/linDialog'

  .edit_stus_info-root
    zuxie-page-root()
    width 1024px
    .excel-dia-content
      display flex
      flex-direction column
      justify-content center
      align-items center
      /*.el-icon-close, .el-icon-close-tip
        display none*/w
      .upload-tips
        margin 10px 0 0
        a
          color $color_suc
    .main-content-wrap
      color $color_white
      font-size $font_size_medium
      line-height inherit
      .nav-wrap
        margin-bottom 25px
        .title
          line-height 1.2
          font-size $font_size_big
        .nav-right
          color: $color_black
          .select
            height: 34px
            border: 1px solid #999
            padding: 0 10px
            outline: 0
          .date
            width: 200px
            margin-right: 10px
          .zuxie-btn
            & + .zuxie-btn
              margin-left 12px
      .center-btn-group
        display block
        text-align center
        .btns {
          display: flex;
          justify-content: center;
          color: $color_white;
          .btn {
            padding: 10px 25px;
            margin: 0 10px;
            border-radius: 4px;
            cursor: pointer;
            user-select: none;
          }
          .save {
            background-color: $color_suc;
          }
          .cancel {
            background-color: $color_err;
          }
        }

      .content-wrap
        display block
        width 100%
        height 590px
        padding 20px 0 15px
        position relative
        background-color $block_bg_color_base
        margin-bottom 10px
        .form-box
          display block
          padding-right 30px
          padding-left 30px
          .form-oneline-wrap
            border-bottom 1px solid rgba(255, 255, 255, 0.6)
            position: relative;
            .stu-name-wrap{
              .el-form-item__error{
                width 200px
              }
            }
            .num {
              position: absolute;
              top: 9px;
              left: -20px;
            }
            &:last-child
              border-bottom none
            & + .form-oneline-wrap
              margin-top 30px
              min-height 70px
            .dia-input-wrap
              float left
              margin-bottom 20px
            .dia-input-w180
              width 180px
            .dia-input-w160
              width 160px
            .name-input
              width 140px
            .phone-input
              width 140px
            .form-oneline-btn
              float left
              margin-left 15px
            .stu-opt
              float left
              width 60px
              height 36px
              font-size 26px
              display flex
              justify-content space-around
              align-items center
              .opt-icon
                cursor pointer
              .disabled
                color $color_info
              .add
                color $color_suc
              .remove
                color $color_err
          .el-form-item.is-required .el-form-item__label:before
            color inherit
          .el-form-item__label
            color $color_white
            font-size 14px
            padding 0 5px 0 0
          .footer-btn
            text-align center
            margin-top 20px

    .footer-btn {
      .btns {
        display: flex;
        justify-content: center;
        color: $color_white;
        .btn {
          padding: 10px 25px;
          margin: 0 10px;
          border-radius: 4px;
          cursor: pointer;
          user-select: none;
        }
        .save {
          background-color: $color_suc;
        }
        .cancel {
          background-color: $color_err;
        }
      }

    }
</style>

